import React from 'react'
import PropTypes from 'prop-types'
import PhoneSalesBanner from '@pcln/phone-sales-banner'
import styled from 'styled-components'
import { Box } from 'pcln-design-system'
import {
  getPhoneNumber,
  onPhoneNumberClick,
} from '../../util/phoneSalesBanner/phoneSalesBanner'

const Wrapper = styled(Box)`
  ${({ theme }) => `
    position: sticky;
    z-index: 1;
    top: 68px;
    ${theme.mediaQueries.sm} {
      position: relative;
      top: 0px;
      z-index: 0;
    }
`}
`

const PhoneSalesBannerWrapper = ({ isDesktop, searchRefId, phoneBookInfo }) => (
  <Wrapper
    px={[2, 2, 2, 2, 0]}
    pb={2}
    pt={[2, 0]}
    mt={[-2, 0]}
    color='background.lightest'
  >
    <PhoneSalesBanner
      phoneNumber={
        phoneBookInfo?.phoneNumber || getPhoneNumber(!isDesktop, searchRefId)
      }
      isDesktop={isDesktop}
      onPhoneNumberClick={onPhoneNumberClick}
      iconBgColor='secondary.base'
      imageUrl={
        'https://s1.pclncdn.com/design-assets/fly-images/phone-rep-image.webp'
      }
    />
  </Wrapper>
)

PhoneSalesBannerWrapper.propTypes = {
  isDesktop: PropTypes.bool,
  searchRefId: PropTypes.string,
  phoneBookInfo: PropTypes.object,
}

export { PhoneSalesBannerWrapper as PhoneSalesBanner }
